"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var translations_context_1 = require("./translations.context");
var translations_1 = __importDefault(require("./translations"));
exports.getTranslation = function (_a) {
    var key = _a.key, currentLanguage = _a.currentLanguage, fallback = _a.fallback, labels = _a.labels;
    if (!labels[key] && fallback) {
        console.log("\"" + key + "\": \"" + fallback + "\"");
    }
    return labels[key] ? labels[key][currentLanguage] : key;
};
var Translations = function (_a) {
    var children = _a.children, appLabels = _a.labels;
    // Add dynamic loading of current language based on user settings later.
    var currentLanguage = react_1.useState('en')[0];
    var context = react_1.useMemo(function () {
        var labels = __assign(__assign({}, appLabels), translations_1.default);
        return {
            getTranslation: function (key, fallback) {
                return exports.getTranslation({ key: key, currentLanguage: currentLanguage, fallback: fallback, labels: labels });
            },
            currentLanguage: currentLanguage,
            formatDuration: function (seconds, options) {
                if (options === void 0) { options = { hoursOnly: false }; }
                var inMinutes = Math.floor((seconds || 0) / 60);
                var hours = Math.floor(inMinutes / 60);
                var minutes = inMinutes % 60;
                var formattedHours = "" + hours + exports.getTranslation({ key: 'DURATIONS:SHORT_HOURS', currentLanguage: currentLanguage, labels: labels });
                if (options.hoursOnly) {
                    return formattedHours;
                }
                var formattedMinutes = "" + minutes + exports.getTranslation({
                    key: 'DURATIONS:SHORT_MINUTES',
                    currentLanguage: currentLanguage,
                    labels: labels,
                });
                if (hours === 0) {
                    return formattedMinutes;
                }
                return formattedHours + " " + formattedMinutes;
            },
        };
    }, [currentLanguage, appLabels]);
    return react_1.default.createElement(translations_context_1.TranslationProvider, { value: context }, children);
};
exports.default = Translations;
